{
  "title": "Terms of Use",
  "preamble": [
    {
      "type": "paragraph",
      "parts": [{ "bold": "Last updated:" }, " February 1, 2026"]
    },
    {
      "type": "paragraph",
      "text": "These Terms of Use (“Terms”) govern your access to and use of the PredictionHero website, products, and services (collectively, the “Services”). By accessing or using the Services, you agree to be bound by these Terms. If you do not agree, do not use the Services."
    }
  ],
  "sections": [
    {
      "heading": { "level": 2, "title": "1. About PredictionHero" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "PredictionHero (“PredictionHero,” “we,” “our,” or “us”) provides aggregated data, analytics, and informational signals derived from third-party prediction markets and related sources. We do not operate a prediction market, broker, exchange, or trading platform."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "2. Eligibility" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "You must be at least 18 years old to use the Services. By using the Services, you represent and warrant that you meet this requirement and have the legal capacity to enter into these Terms."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "3. Informational Use Only — No Advice" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "All content provided through the Services is for informational and educational purposes only."
        },
        {
          "type": "paragraph",
          "text": "Nothing on PredictionHero constitutes:"
        },
        {
          "type": "list",
          "items": [
            "Financial advice",
            "Investment advice",
            "Legal advice",
            "Trading recommendations"
          ]
        },
        {
          "type": "paragraph",
          "text": "Prediction markets and related instruments are speculative and involve risk. You are solely responsible for your own decisions and actions. Always conduct your own research and consult qualified professionals before making decisions involving risk."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "4. No Affiliation or Endorsement" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "PredictionHero is not affiliated with, endorsed by, or sponsored by any prediction market, exchange, or data provider unless explicitly stated. All third-party names, trademarks, and data belong to their respective owners."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "5. User Accounts (If Applicable)" },
      "blocks": [
        { "type": "paragraph", "text": "If you create an account:" },
        {
          "type": "list",
          "items": [
            "You are responsible for maintaining the confidentiality of your credentials",
            "You are responsible for all activity under your account",
            "You agree to provide accurate and current information"
          ]
        },
        {
          "type": "paragraph",
          "text": "We reserve the right to suspend or terminate accounts that violate these Terms."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "6. Acceptable Use" },
      "blocks": [
        { "type": "paragraph", "text": "You agree not to:" },
        {
          "type": "list",
          "items": [
            "Use the Services for unlawful purposes",
            "Attempt to reverse engineer, scrape, or abuse the platform",
            "Interfere with the operation or security of the Services",
            "Misrepresent PredictionHero or its data",
            "Use the Services to provide regulated advice without authorization"
          ]
        },
        {
          "type": "paragraph",
          "text": "We reserve the right to restrict access for violations."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "7. Intellectual Property" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "All content on the Services, including text, design, logos, graphics, data compilations, and software, is owned by or licensed to PredictionHero and protected by intellectual property laws."
        },
        {
          "type": "paragraph",
          "text": "You may not copy, reproduce, distribute, or create derivative works without prior written consent, except for personal, non-commercial use."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "8. Third-Party Content and Links" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "The Services may include data, links, or references to third-party websites or services. We do not control and are not responsible for third-party content, availability, accuracy, or practices. Use of third-party services is at your own risk."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "9. Disclaimers" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "The Services are provided “as is” and “as available.”"
        },
        {
          "type": "paragraph",
          "text": "We make no warranties, express or implied, including but not limited to:"
        },
        {
          "type": "list",
          "items": [
            "Accuracy or completeness of data",
            "Availability or uptime",
            "Fitness for a particular purpose",
            "Non-infringement"
          ]
        },
        {
          "type": "paragraph",
          "text": "PredictionHero does not guarantee outcomes, performance, or results."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "10. Limitation of Liability" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "To the maximum extent permitted by law, PredictionHero shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including loss of profits, data, or opportunities, arising from or related to your use of the Services."
        },
        {
          "type": "paragraph",
          "text": "Our total liability shall not exceed the amount you paid us (if any) in the preceding 12 months."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "11. Indemnification" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "You agree to indemnify and hold harmless PredictionHero and its affiliates, officers, directors, and employees from any claims, liabilities, damages, or expenses arising from:"
        },
        {
          "type": "list",
          "items": [
            "Your use of the Services",
            "Your violation of these Terms",
            "Your violation of any law or third-party rights"
          ]
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "12. Termination" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "We may suspend or terminate your access to the Services at any time, with or without notice, for any reason, including violation of these Terms."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "13. Modifications to the Services or Terms" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "We may modify or discontinue the Services at any time."
        },
        {
          "type": "paragraph",
          "text": "We may update these Terms from time to time. Continued use after updates constitutes acceptance of the revised Terms."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "14. Governing Law" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "These Terms are governed by and construed in accordance with the laws of the United States, without regard to conflict-of-laws principles."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "15. Dispute Resolution" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "Any dispute arising out of or relating to these Terms or the Services shall be resolved through binding arbitration, except where prohibited by law. You waive any right to participate in class actions or class-wide arbitration."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "16. Severability" },
      "blocks": [
        {
          "type": "paragraph",
          "text": "If any provision of these Terms is found unenforceable, the remaining provisions will remain in full force and effect."
        }
      ]
    },
    {
      "heading": { "level": 2, "title": "17. Contact Information" },
      "blocks": [
        {
          "type": "paragraph",
          "parts": [
            "If you have any questions about these Terms, please ",
            { "intercom": "contact us." }
          ]
        }
      ]
    }
  ]
}
